__turbopack_context__.v({
  "accordionRoot": "ZXS5cG_accordionRoot",
  "desktopTable": "ZXS5cG_desktopTable",
  "mobileAccordion": "ZXS5cG_mobileAccordion",
  "technicalSpec": "ZXS5cG_technicalSpec",
  "technicalSpecsRoot": "ZXS5cG_technicalSpecsRoot",
  "twoImageRoot": "ZXS5cG_twoImageRoot",
});
